<template>
  <div>
    <vetster-slide-over-common-heading
      :show-close="false"
      show-back
      is-simple-heading
      class="sticky pt-4 -top-1 bg-white"
      @back="$emit('previous', $event)"
    >
      <div class="text-3xl font-bold border-l ml-4 pl-2 border-neutral-200 font-title leading-none text-neutral-900">
        <vetster-reviews-count :partner="partner" />
      </div>
    </vetster-slide-over-common-heading>
    <vetster-px-review-list
      ref="reviewList"
      :partner="partner"
      class="px-standard"
    />
  </div>
</template>

<script>
import VetsterPxReviewList from '@/brand-components/VetsterPxReviewList';
import VetsterReviewsCount from '@/brand-components/VetsterReviewsCount';
import VetsterSlideOverCommonHeading from '@/brand-components/VetsterSlideOverCommonHeading';

export default {
  name: 'VetsterPartnerDetailsReviews',

  components: {
    VetsterPxReviewList,
    VetsterReviewsCount,
    VetsterSlideOverCommonHeading,
  },

  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
};
</script>
